// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"57d828f8","455":"5baad9d4","977":"f6548411"}[chunkId] + ".chunk.js";
};